import { Card } from "@/components/ui/card";
import { Building2, CreditCard, CircleDollarSign, Activity } from "lucide-react";

const items = [
  { key: "total_subaccounts", label: "Sub-Accounts", icon: Building2, tint: "text-primary" },
  { key: "square_connected", label: "Square Linked", icon: CreditCard, tint: "text-emerald-400" },
  { key: "stripe_connected", label: "Stripe Linked", icon: CreditCard, tint: "text-indigo-400" },
  { key: "successful_transactions", label: "Payments", icon: Activity, tint: "text-primary" },
];

export default function StatsBar({ stats }) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-5 gap-3">
      {items.map((it) => {
        const Icon = it.icon;
        return (
          <Card
            key={it.key}
            data-testid={`stat-${it.key}`}
            className="p-4 border-border/70 hover:border-primary/40 transition-colors"
          >
            <div className="flex items-center justify-between">
              <span className="text-xs font-mono uppercase tracking-wider text-muted-foreground">{it.label}</span>
              <Icon className={`h-4 w-4 ${it.tint}`} />
            </div>
            <div className="mt-2 font-heading text-2xl font-bold">{stats?.[it.key] ?? 0}</div>
          </Card>
        );
      })}
      <Card className="p-4 border-border/70 hover:border-primary/40 transition-colors">
        <div className="flex items-center justify-between">
          <span className="text-xs font-mono uppercase tracking-wider text-muted-foreground">Volume</span>
          <CircleDollarSign className="h-4 w-4 text-emerald-400" />
        </div>
        <div className="mt-2 font-heading text-2xl font-bold">${(stats?.total_volume ?? 0).toFixed(2)}</div>
      </Card>
    </div>
  );
}
